<template>
    <transition name="loader-fade">
        <div v-if="visible" class="initial-loader" aria-busy="true">
            <div class="initial-loader__inner">
                <!-- ロゴ切り替え（指定どおり assets を使用） -->
                <img v-if="$store.state.hostName === 'R2' || $store.state.hostName === 'Y2'" src="@/assets/logo-second-white.svg" alt="RODEO BROS" class="initial-loader__logo" @load="onLogoLoaded" />
                <img v-else-if="$store.state.hostName !== 'W'" src="@/assets/logo-white.svg" alt="RODEO BROS" class="initial-loader__logo" @load="onLogoLoaded" />
                <img v-else src="https://image.wowma.jp/24431709/img/logo-white.png" alt="RODEO BROS" class="initial-loader__logo" @load="onLogoLoaded" />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'InitialLoader',

  data () {
    return {
      visible: true,
      logoLoaded: false,
      // JSON取得は待たない：最低表示時間のみ保証
      minDurationMs: 1400
    }
  },

  methods: {
    onLogoLoaded () {
      this.logoLoaded = true
      // ロゴ表示 → 少し見せてから解除
      setTimeout(this.close, this.minDurationMs)
    },

    close () {
      if (!this.visible) return
      this.visible = false
      this.$emit('closed')
    }
  },

  mounted () {
    /**
     * Vue起動前の黒シェルを除去
     * （index.html の #boot-splash を引き継ぐ）
     */
    const bootSplash = document.getElementById('boot-splash')
    if (bootSplash) bootSplash.remove()

    const startedAt = Date.now()

    const closeWithMinDuration = () => {
      const elapsed = Date.now() - startedAt
      const wait = Math.max(0, this.minDurationMs - elapsed)
      setTimeout(this.close, wait)
    }

    /**
     * ロゴが読み込めなかった場合の保険
     * → 必ず minDuration 経過後に解除
     */
    setTimeout(() => {
      if (!this.logoLoaded) closeWithMinDuration()
    }, this.minDurationMs)
  }

}
</script>

<style scoped lang="scss">
.initial-loader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000;
}

.initial-loader__inner {
    display: flex;
    justify-content: center;
    // width: min(520px, 86vw);
    width: 240px;
    padding: 24px;
}

.initial-loader__logo {
    width: 100%;
    height: auto;
    opacity: 0;
    transform: translateY(0);
    animation:
        logoFadeIn 900ms ease forwards 200ms,
        logoSlideOut 800ms ease-in forwards 1400ms;
}

@keyframes logoFadeIn {
    to {
        opacity: 1;
    }
}

@keyframes logoSlideOut {
    to {
        opacity: 0;
        transform: translateY(-24px);
    }
}

.loader-fade-enter-active,
.loader-fade-leave-active {
    transition: opacity 900ms ease;
    transition-delay: 300ms;
}

.loader-fade-enter,
.loader-fade-leave-to {
    opacity: 0;
}
</style>
